export const RESIDENT_PRE_QUALIFICATION_STRINGS = {
  back: 'Back',
  'form.title': 'Quick Fit Check',
  'form.subtitle':
    "Answer two questions now to see if you'll qualify for this home and save you time. Later, we'll run a real credit and income check if you apply.",
  'form.incomeQuestion':
    'What is the combined annual income of everyone who will be on the lease?',
  'form.incomeLabel': 'Combined Pre-Tax Income ($/Year)',
  'form.incomeMaxValidation': 'Please enter a lower income.',
  'form.creditQuestion': 'Give us a rough idea of your Credit Score.',
  'form.submit': 'Estimate My Chances',
  'form.error':
    'There was an error checking your fit for this home. Please try again.',
  'creditBand.Poor.title': 'Below 620',
  'creditBand.Poor.hint': 'Building It Up',
  'creditBand.Fair.title': '620 To 699',
  'creditBand.Fair.hint': 'Fair',
  'creditBand.Good.title': '700 Or Higher',
  'creditBand.Good.hint': 'Good To Excellent',
  'result.rentIncome': '{multiple}x Rent Income',
  'result.credit.Poor': 'Credit Below 620',
  'result.credit.Fair': 'Credit 620 To 699',
  'result.credit.Good': 'Credit 700 Or Higher',
  'result.Qualified.title': 'This home looks like a great fit!',
  'result.Qualified.body':
    "Your income and credit both should qualify for this home. We'll confirm this when you apply. In the meantime, let's get you in to see this home!",
  'result.CosignerRequired.title': 'You’re close on this one.',
  'result.CosignerRequired.body':
    'While you’re right at the edge of qualifying for this home, you’re still welcome to tour. Later, a roommate or guarantor with strong credit may help you qualify when you apply.',
  'result.NotQualified.title': 'Thank you for being honest.',
  'result.NotQualified.body':
    'Based on the information you provided, it is unlikely you would qualify for this home. We recommend adding a guarantor to strengthen your application, or looking for other homes that may be a better fit.',
  'result.browseOtherHomes': 'Browse Other Homes',
  'cta.BookTour': 'Book My Group Tour',
  'cta.RequestTour': 'Continue & Share Availability',
};
